import { Chip, ChipProps } from '@mui/material'
import React from 'react'

interface ITag extends Omit<ChipProps, 'color'> {
  background?: string
  color?: string
}

export default function Tag({ color, background, ...props }: ITag) {
  return (
    <Chip
      sx={{
        color: color ?? 'white',
        backgroundColor: background ?? 'grey.700',
        border: 0,
        borderRadius: '6px',
        height: '23px',
        fontWeight: 600,
        fontSize: '11px',
        lineHeight: '15px',
        textTransform: 'capitalize',
      }}
      {...props}
    />
  )
}
